import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { labRequestAssignments } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTASSIGNMENT,
  DELETE_LABREQUESTASSIGNMENT,
  GET_LABREQUESTASSIGNMENTS,
  UPDATE_LABREQUESTASSIGNMENT
} from "./actionTypes";
import {
  addLabRequestAssignmentFail,
  addLabRequestAssignmentSuccess,
  deleteLabRequestAssignmentFail,
  deleteLabRequestAssignmentSuccess,
  getLabRequestAssignmentsFail,
  getLabRequestAssignmentsSuccess,
  setState,
  updateLabRequestAssignmentFail,
  updateLabRequestAssignmentSuccess,
} from "./actions";

//Include Both Helper File with needed methods

function* fetchLabRequestAssignments( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable,labRequestAssignments, params.toString());
    yield put(setState(false))
    yield put(getLabRequestAssignmentsSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestAssignmentsFail(error));
  }
}

function* updateLabRequestAssignment ({payload: labRequestAssignmentObj }) {
  try {
    const { id, recordStatus, ...rest } = labRequestAssignmentObj;
    yield call(patchApiCall, `${labRequestAssignments}/${id}`, rest);
    const response = yield call(getTable,`${labRequestAssignments}/${labRequestAssignmentObj.id}`);
    yield put(updateLabRequestAssignmentSuccess(response));
  } catch (error) {
    yield put(updateLabRequestAssignmentFail(error));
  }
}

function* deleteLabRequestAssignment ({payload: labRequestAssignmentObj}) {
  try {
    yield call(deleteApiCall,`${labRequestAssignments}/${labRequestAssignmentObj.id}` );
    yield put(deleteLabRequestAssignmentSuccess(labRequestAssignmentObj.id));
  } catch (error) {
    yield put(deleteLabRequestAssignmentFail(error));
  }
}

function* postingLabRequestAssignment ({ payload: labRequestAssignment}) {
  try {
    const response = yield call(postApiCall, labRequestAssignments ,labRequestAssignment);
    const response1 = yield call(getTable,`${labRequestAssignments}/${response.id}`);
    yield put(addLabRequestAssignmentSuccess(response1));
  } catch (error) {
    yield put(addLabRequestAssignmentFail(error));
  }
}

function* labRequestAssignmentsSaga() {
  yield takeEvery(GET_LABREQUESTASSIGNMENTS, fetchLabRequestAssignments);
  yield takeEvery(ADD_NEW_LABREQUESTASSIGNMENT, postingLabRequestAssignment);
  yield takeEvery(UPDATE_LABREQUESTASSIGNMENT, updateLabRequestAssignment);
  yield takeEvery(DELETE_LABREQUESTASSIGNMENT, deleteLabRequestAssignment);
}

export default labRequestAssignmentsSaga;
